import React from 'react';
import { AppBar, Toolbar, Grid, Button } from '@material-ui/core';
import logoSoma from '../assets/images/logos/logoSoma.jpg'
import useUser, { useAuth } from '../Hooks/UserContext';
import Show from './SomaStandard/AuthComponents/Show';
import MuiRouterLink from './MuiRouterLink';

const BasePage = (props) => {
  const user = useUser();
  const { logoff } = useAuth();

  return (
    <Grid style={Object.assign(props.style || {}, { height: "100vh", display: "flex", flexDirection: "column" })}>
      <AppBar position="relative" style={{backgroundColor: "#FFFFFF" }}>
        <Toolbar>
          <Grid container alignItems="center" justify="space-between" direction="row" >
            <Grid item>
              <MuiRouterLink href="\">
                <img src={logoSoma} style={{ marginLeft: '10px', height: '35px' }} alt="Logo do Soma" />
              </MuiRouterLink>
            </Grid>
            <Show>
              <Grid item xs container justify="flex-end" spacing={2} alignItems="center">
                <Grid item style={{margin:"0 32.31px"}}>
                  <Grid container justify="center" direction='column'>
                    <Grid item>
                      <span style={{ color: "#000000", fontFamily: 'flama-medium', fontSize: '12px' }}>OLÁ {user.cliente},</span>
                    </Grid>
                    <Grid style={{ color: "#000000", fontFamily: 'flama-medium', fontSize: '12px' }}>TUDO BOM?</Grid>
                  </Grid>
                </Grid>
                <Grid>
                  <Button style={{ color: "#747474", fontFamily: 'flama-medium', textDecoration: 'underline', fontSize: '13px', fontWeight: '600' }} size="small" onClick={logoff.dispatch}>
                    SAIR
                  </Button>
                </Grid>
              </Grid>
            </Show>
          </Grid>
        </Toolbar>
      </AppBar>
      <Grid style={{ height: "100%", overflowY: "auto" }}>
        {props.children}
      </Grid>
    </Grid>
  )

}

export default BasePage